import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import unscheduledPlaceholder from "../../assets/img/session-placeholeder.png";
import PlaceHolder from "../placeHolder.tsx/PlaceHolder";

function UnscheduledReader() {
  const LocalBasePath = "page.candidate.dashboard.UnscheduledReader";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <div className=" w-full h-full flex flex-col gap-4 md:gap-0">
      <div className="w-full py-5 px-6 border-b border-gray-200">
        <h3 className="text-gray-900 font-semibold text-2xl">
          {t("readingRoom")}
        </h3>
      </div>
      <div className="my-auto  pb-2 md:pb-0 text-center  flex gap-6 flex-col justify-center items-center w-full">
        <PlaceHolder
          img={unscheduledPlaceholder}
          description={"tutorDecision"}
          title={"createdAccount"}
        />
        <div className="w-full">
          <Link
            to={"/reading-room-etiquette"}
            className="text-brandblue-600 text-sm leading-6 font-medium"
          >
            {t(`readingRoomEtiquette`)}
          </Link>
        </div>
        <div className="w-full">
          <Link
            to={"/politics"}
            className="text-brandblue-600 text-sm leading-6 font-medium"
          >
            {t(`politics`)}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default UnscheduledReader;
